'use strict';

import React from 'react';
import { render } from 'react-dom';
import ApolloClient from 'apollo-boost';
import { gql } from "apollo-boost";
import 'isomorphic-unfetch' // Fixes IE
import SearchInput from "./SearchInput";
import SearchSuggestions from "./SearchSuggestions";

class SuggestiveSearch extends React.Component {
    constructor(props) {
        super(props);

        this.baseUrl = solout.baseUrl;
        this.graphQLUrl = this.baseUrl + "graphql";
        this.searchFormActionUrl = `${this.baseUrl}home/SearchForm/`;

        this.state = {
            suggestions: [],
            showSuggestions: false,
            formAction: this.searchFormActionUrl
        };

        this.apolloClient = new ApolloClient({
            fetchOptions: { fetch },
            uri: this.graphQLUrl,
        });

        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    }

    handleSearchInputChange(event) {

        if (this.graphQLUrl.length === 0 || this.apolloClient === null) {
            return;
        }

        if (event.keyCode === 27) {
            this.setState({
                showSuggestions: false
            });

            return;
        }

        if (event.target.value.length < 2) {
            this.setState({
                suggestions: [],
                showSuggestions: false
            });

            return;
        }

        // Request pages from the GraphQL endpoint
        this.apolloClient.query({
            query: gql`
              {
                  Page(Search: "${event.target.value}", Limit: 4) {
                    Title
                    Summary
                    MetaDescription
                    AbsoluteLink
                  }
              }
`
        })
            .then((result) => {
                this.setState({
                    suggestions: result.data.Page,
                    showSuggestions: true
                });
            });
    }

    render() {
        return (
            <div className='suggestive-search-container'>
                <SearchInput onKeyPress={this.handleSearchInputChange} formAction={this.state.formAction} />
                <SearchSuggestions suggestions={this.state.suggestions} showSuggestions={this.state.showSuggestions} />
            </div>
        );
    }
}

render(<SuggestiveSearch />, document.querySelector('#suggestive-search'));
